import { render } from "./myFinishHomework.vue?vue&type=template&id=5fd609c8&scoped=true"
import script from "./myFinishHomework.vue?vue&type=script&lang=js"
export * from "./myFinishHomework.vue?vue&type=script&lang=js"

import "./myFinishHomework.vue?vue&type=style&index=0&id=5fd609c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd609c8"]])

export default __exports__